// Turks (tr-TR), ridesApp: zelfde vorm als ridesApp.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm). {role} in whoInstead/takenOver is een
// werkwoord ("götürüyor"/"alıyor"), elders het zelfstandig naamwoord ("Götürme"/"Alma").
export const appRidesTr = {
    unknown: 'Henüz belli değil',
    notNeeded: 'Gerek yok',
    perDay: 'Güne göre farklı',
    perDayHint: 'Örneğin pazartesi {a}, perşembe {b}.',
    perDayHintOne: 'Örneğin pazartesi başka biri, perşembe başka biri.',
    sameEveryDay: 'Her seferinde aynı kişi',
    day: 'Gün',
    roleOnDay: '{day}: {role}',
    change: 'Değiştir',
    close: 'Tamam',
    droppedDays: {
        one: '{days} için sürücü seçimi kalkıyor: o gün artık tekrarda yok.',
        other: '{days} için sürücü seçimi kalkıyor: o günler artık tekrarda yok.',
    },
    cantDrive: 'Gidemiyor musun? Başkası gitsin',
    iCant: 'Ben gidemem, açık kalsın',
    someoneElse: 'Başkası gidecek',
    whoInstead: '{date} günü kim {role}?',
    whoInsteadHint: 'Sadece bu sefer. Diğer seferler olduğu gibi kalır.',
    onlyThisTime: 'Sadece bu sefer',
    usually: 'normalde {name}',
    usuallyNobody: 'normalde henüz kimse',
    everyWeekday: 'her {day}',
    backToUsual: 'Normale dön',
    takenOver: '{name} bu sefer {role}',
    nobodyNow: '{role}: bu sefer "Kim gidecek?" olarak duruyor. Diğerleri görüyor.',
    backDone: '{role} yine normal düzende',
    verbDropoff: 'götürüyor',
    verbPickup: 'alıyor',
};
//# sourceMappingURL=ridesApp.tr.js.map